import { apiClient } from "../apiClient";

export const API_APP_BAIVIET_REACT_PATH = "app-bai-viet-react"

export const appBaiVietReactApi = {
    SelectAll: (app_baiviet_id: number) => apiClient.get(API_APP_BAIVIET_REACT_PATH + '/' + app_baiviet_id)
}